/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  ConflictResponse,
  ForbiddenResponse,
  ListPeopleParams,
  LoginRequest,
  LoginResult,
  Me,
  MfaEnrollmentResult,
  MfaVerificationRequest,
  NotFoundResponse,
  Person,
  ReauthenticationRequest,
  ReauthenticationResult,
  ServiceUnavailableResponse,
  TermsAcceptanceRequest,
  TermsDocument,
  TooManyRequestsResponse,
  UnauthorizedResponse,
  UnprocessableEntityResponse,
  UpdatePreferencesRequest
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListPeopleUrl = (params?: ListPeopleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/people?${stringifiedParams}` : `/v1/people`
}

/**
 * Super Admin lista todas as pessoas e recebe `displayName` com nome
 * completo. Professor lista apenas alunos vinculados a ele e recebe
 * `displayName` mascarado. Aluno e suporte recebem 403.
 * @summary Lista pessoas visiveis ao solicitante
 */
export const listPeople = async (params?: ListPeopleParams, options?: Parameters<typeof apiFetch>[1]): Promise<Person[]> => {

  return apiFetch<Person[]>(getListPeopleUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPeopleQueryKey = (params?: ListPeopleParams,) => {
    return [
    `/v1/people`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPeopleQueryOptions = <TData = Awaited<ReturnType<typeof listPeople>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPeopleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPeople>>> = ({ signal }) => listPeople(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof listPeople>>>
export type ListPeopleQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListPeople<TData = Awaited<ReturnType<typeof listPeople>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListPeopleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPeople>>,
          TError,
          Awaited<ReturnType<typeof listPeople>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPeople<TData = Awaited<ReturnType<typeof listPeople>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPeople>>,
          TError,
          Awaited<ReturnType<typeof listPeople>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPeople<TData = Awaited<ReturnType<typeof listPeople>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista pessoas visiveis ao solicitante
 */

export function useListPeople<TData = Awaited<ReturnType<typeof listPeople>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListPeopleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPeopleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLoginUrl = () => {




  return `/v1/auth/login`
}

/**
 * Em caso de sucesso responde com `Set-Cookie: pv_session`, cookie
 * `HttpOnly`, `Secure`, `SameSite=Lax`. Nenhum token trafega em corpo de
 * resposta nem e manipulado em JavaScript.
 *
 * Credencial invalida e e-mail inexistente produzem **a mesma** resposta
 * 401, para nao permitir enumeracao de conta. Quando o papel exige segundo
 * fator, a sessao emitida nao autoriza nada alem da inscricao ou da
 * verificacao de MFA: `mfa_enrollment_required` quando falta inscricao,
 * `mfa_required` quando falta verificar o codigo.
 * @summary Autentica por e-mail e senha e emite a sessao
 */
export const login = async (loginRequest: LoginRequest, options?: Parameters<typeof apiFetch>[1]): Promise<LoginResult> => {

  return apiFetch<LoginResult>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginRequest)
  }
);}





export const getLoginMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | TooManyRequestsResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginRequest
    export type LoginMutationError = BadRequestResponse | UnauthorizedResponse | TooManyRequestsResponse

    /**
 * @summary Autentica por e-mail e senha e emite a sessao
 */
export const useLogin = <TError = BadRequestResponse | UnauthorizedResponse | TooManyRequestsResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }
    export const getLogoutUrl = () => {




  return `/v1/auth/logout`
}

/**
 * Revoga a sessao no servidor e expira o cookie no navegador.
 * @summary Revoga a sessao corrente
 */
export const logout = async ( options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMutationOptions = <TError = UnauthorizedResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = UnauthorizedResponse

    /**
 * @summary Revoga a sessao corrente
 */
export const useLogout = <TError = UnauthorizedResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options), queryClient);
    }
    export const getReauthenticateUrl = () => {




  return `/v1/auth/reauthentication`
}

/**
 * Toda operacao descrita neste contrato como **sensivel** exige
 * reautenticacao recente: a sessao precisa ter reconfirmado a credencial
 * dentro de uma janela curta, contada a partir daqui. Esta e a unica
 * operacao que abre essa janela. Sem ela, as operacoes sensiveis respondem
 * 403 para sempre — inclusive as que tirariam o preco do placeholder, o
 * que deixaria a plataforma presa no estado provisorio.
 *
 * **O corpo pede a senha, e nada alem dela.** A sessao ja diz quem e a
 * pessoa; o que falta reconfirmar e a posse da credencial, nao a
 * identidade. Pedir o e-mail outra vez seria pior de duas maneiras
 * independentes. Primeiro, `getMe` nao devolve e-mail — e nao deve passar
 * a devolver so para alimentar esta tela —, entao a SPA nao teria como
 * preencher o campo, e sobraria digitacao numa tela que a pessoa ja
 * atravessou e onde ela vai errar. Segundo, um e-mail aceito aqui faria
 * desta rota um verificador de credencial de **qualquer** conta,
 * alcancavel de dentro de uma sessao legitima; e se o e-mail viesse e nao
 * batesse com o da sessao, a unica resposta defensavel seria a mesma
 * recusa de sempre — ou seja, o campo nao carregaria informacao alguma e
 * so acrescentaria superficie de ataque.
 *
 * **O segundo fator entra quando ele existe.** Quem tem inscricao TOTP
 * confirmada (`Me.mfaEnrolled`) manda `totpCode` junto da senha: uma
 * reautenticacao que pedisse menos do que o proprio login daquela pessoa
 * protegeria menos do que ele, e do outro lado desta janela estao as
 * operacoes que movem dinheiro. Quem nao tem inscricao confirmada omite o
 * campo. Exigir o segundo fator tambem de quem nao tem MFA obrigatorio
 * depende de a §15.2 fechar se o MFA se estende ao professor: e valor de
 * configuracao, nao forma de operacao, e esta registrado como pendencia.
 *
 * Senha errada, codigo errado e codigo ausente quando ele era exigido
 * respondem **o mesmo 422**, sem dizer qual dos tres falhou. A ausencia do
 * codigo e verificada **antes** de qualquer verificacao de senha, para que
 * esse 422 nao conte nada sobre a senha. E 422, e nao 401, porque a sessao
 * continua valida: 401 neste contrato diz "identifique-se", e todo
 * interceptador de SPA reage a ele mandando a pessoa para o login — um
 * erro de digitacao derrubaria a sessao e o trabalho da tela junto. O que
 * a regra recusou foi o conteudo do corpo, que e exatamente o que 422 diz.
 * O 401 fica reservado a ausencia de sessao.
 *
 * A rota **precisa** de limite de tentativas, e por isso responde 429: ela
 * e um verificador de senha alcancavel por quem ja tem o cookie, que e
 * justamente o cenario de sessao roubada. As tentativas erradas contam
 * contra a mesma pessoa e no mesmo limite que o `login` conta; contadores
 * separados fariam desta rota o desvio do limite daquele.
 *
 * O 503 e outra coisa, e por isso tem status proprio: e o teto de
 * verificacoes de senha simultaneas, que protege o processo do custo do
 * algoritmo de derivacao. A causa e capacidade do servidor, nao excesso de
 * quem chamou, e quem e recusado costuma ser justamente quem nao esta
 * atacando — dar 429 aos dois apagaria, no cliente e na observabilidade, a
 * diferenca entre "esta conta esta travada" e "o servidor esta saturado",
 * que pedem reacoes opostas.
 *
 * Exige sessao plena: sessao pendente de segundo fator nao alcanca esta
 * rota, porque reautenticar nao e caminho para completar login.
 * @summary Reconfirma a credencial e abre a janela de operacao sensivel
 */
export const reauthenticate = async (reauthenticationRequest: ReauthenticationRequest, options?: Parameters<typeof apiFetch>[1]): Promise<ReauthenticationResult> => {

  return apiFetch<ReauthenticationResult>(getReauthenticateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reauthenticationRequest)
  }
);}





export const getReauthenticateMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | UnprocessableEntityResponse | TooManyRequestsResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reauthenticate>>, TError,{data: ReauthenticationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reauthenticate>>, TError,{data: ReauthenticationRequest}, TContext> => {

const mutationKey = ['reauthenticate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reauthenticate>>, {data: ReauthenticationRequest}> = (props) => {
          const {data} = props ?? {};

          return  reauthenticate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReauthenticateMutationResult = NonNullable<Awaited<ReturnType<typeof reauthenticate>>>
    export type ReauthenticateMutationBody = ReauthenticationRequest
    export type ReauthenticateMutationError = BadRequestResponse | UnauthorizedResponse | UnprocessableEntityResponse | TooManyRequestsResponse | ServiceUnavailableResponse

    /**
 * @summary Reconfirma a credencial e abre a janela de operacao sensivel
 */
export const useReauthenticate = <TError = BadRequestResponse | UnauthorizedResponse | UnprocessableEntityResponse | TooManyRequestsResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reauthenticate>>, TError,{data: ReauthenticationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reauthenticate>>,
        TError,
        {data: ReauthenticationRequest},
        TContext
      > => {
      return useMutation(getReauthenticateMutationOptions(options), queryClient);
    }
    export const getGetMeUrl = () => {




  return `/v1/me`
}

/**
 * Devolve `displayName` ja mascarado conforme o proprio papel de quem
 * consulta. Um aluno consultando a si mesmo recebe `Joao S.`, sem excecao
 * para o titular do dado.
 * @summary Descreve quem esta autenticado
 */
export const getMe = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Me> => {

  return apiFetch<Me>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/v1/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = UnauthorizedResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = UnauthorizedResponse


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = UnauthorizedResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Descreve quem esta autenticado
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateMyPreferencesUrl = () => {




  return `/v1/me/preferences`
}

/**
 * O fuso e identificador IANA, como `America/New_York`. Deslocamento fixo
 * e recusado com 422: `-03:00` nao carrega as regras de transicao e
 * tornaria impossivel calcular a virada de horario de verao.
 * @summary Altera idioma e fuso da propria conta
 */
export const updateMyPreferences = async (updatePreferencesRequest: UpdatePreferencesRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Me> => {

  return apiFetch<Me>(getUpdateMyPreferencesUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePreferencesRequest)
  }
);}





export const getUpdateMyPreferencesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyPreferences>>, TError,{data: UpdatePreferencesRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyPreferences>>, TError,{data: UpdatePreferencesRequest}, TContext> => {

const mutationKey = ['updateMyPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyPreferences>>, {data: UpdatePreferencesRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateMyPreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyPreferences>>>
    export type UpdateMyPreferencesMutationBody = UpdatePreferencesRequest
    export type UpdateMyPreferencesMutationError = BadRequestResponse | UnauthorizedResponse | UnprocessableEntityResponse

    /**
 * @summary Altera idioma e fuso da propria conta
 */
export const useUpdateMyPreferences = <TError = BadRequestResponse | UnauthorizedResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyPreferences>>, TError,{data: UpdatePreferencesRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMyPreferences>>,
        TError,
        {data: UpdatePreferencesRequest},
        TContext
      > => {
      return useMutation(getUpdateMyPreferencesMutationOptions(options), queryClient);
    }
    export const getGetCurrentTermsUrl = () => {




  return `/v1/terms/current`
}

/**
 * Sem sessao, o locale vem da negociacao por `Accept-Language`. Com sessao,
 * vem da pessoa. Quando nao existe documento no locale pedido, a resposta
 * traz o documento em `pt-BR`, e e esse o documento que o aceite registra.
 *
 * Enquanto `version` for `0.0.0-placeholder`, o texto e um marcador sem
 * valor juridico e a interface precisa apresenta-lo como tal.
 * @summary Lista os termos vigentes no locale do solicitante
 */
export const getCurrentTerms = async ( options?: Parameters<typeof apiFetch>[1]): Promise<TermsDocument[]> => {

  return apiFetch<TermsDocument[]>(getGetCurrentTermsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentTermsQueryKey = () => {
    return [
    `/v1/terms/current`
    ] as const;
    }


export const getGetCurrentTermsQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentTerms>>, TError = UnauthorizedResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentTerms>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentTermsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentTerms>>> = ({ signal }) => getCurrentTerms({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentTerms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentTerms>>>
export type GetCurrentTermsQueryError = UnauthorizedResponse


export function useGetCurrentTerms<TData = Awaited<ReturnType<typeof getCurrentTerms>>, TError = UnauthorizedResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentTerms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentTerms>>,
          TError,
          Awaited<ReturnType<typeof getCurrentTerms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentTerms<TData = Awaited<ReturnType<typeof getCurrentTerms>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentTerms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentTerms>>,
          TError,
          Awaited<ReturnType<typeof getCurrentTerms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentTerms<TData = Awaited<ReturnType<typeof getCurrentTerms>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentTerms>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os termos vigentes no locale do solicitante
 */

export function useGetCurrentTerms<TData = Awaited<ReturnType<typeof getCurrentTerms>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentTerms>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentTermsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAcceptTermsUrl = () => {




  return `/v1/terms/acceptances`
}

/**
 * O registro guarda pessoa, documento, sessao e instante, e e append-only
 * no banco. Aceitar duas vezes o mesmo documento responde 409 e nao duplica
 * registro.
 * @summary Registra o aceite de um documento de termos
 */
export const acceptTerms = async (termsAcceptanceRequest: TermsAcceptanceRequest, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getAcceptTermsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(termsAcceptanceRequest)
  }
);}





export const getAcceptTermsMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerms>>, TError,{data: TermsAcceptanceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptTerms>>, TError,{data: TermsAcceptanceRequest}, TContext> => {

const mutationKey = ['acceptTerms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptTerms>>, {data: TermsAcceptanceRequest}> = (props) => {
          const {data} = props ?? {};

          return  acceptTerms(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptTermsMutationResult = NonNullable<Awaited<ReturnType<typeof acceptTerms>>>
    export type AcceptTermsMutationBody = TermsAcceptanceRequest
    export type AcceptTermsMutationError = BadRequestResponse | UnauthorizedResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Registra o aceite de um documento de termos
 */
export const useAcceptTerms = <TError = BadRequestResponse | UnauthorizedResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerms>>, TError,{data: TermsAcceptanceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptTerms>>,
        TError,
        {data: TermsAcceptanceRequest},
        TContext
      > => {
      return useMutation(getAcceptTermsMutationOptions(options), queryClient);
    }
    export const getEnrollMfaUrl = () => {




  return `/v1/mfa/enrollment`
}

/**
 * Devolve o segredo e a URI `otpauth://` uma unica vez, antes da
 * confirmacao. Depois de confirmado por `verifyMfa`, nenhuma operacao
 * devolve o segredo de novo; inscricao ja confirmada responde 409.
 * @summary Inicia a inscricao no segundo fator TOTP
 */
export const enrollMfa = async ( options?: Parameters<typeof apiFetch>[1]): Promise<MfaEnrollmentResult> => {

  return apiFetch<MfaEnrollmentResult>(getEnrollMfaUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEnrollMfaMutationOptions = <TError = UnauthorizedResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollMfa>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enrollMfa>>, TError,void, TContext> => {

const mutationKey = ['enrollMfa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enrollMfa>>, void> = () => {


          return  enrollMfa(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnrollMfaMutationResult = NonNullable<Awaited<ReturnType<typeof enrollMfa>>>

    export type EnrollMfaMutationError = UnauthorizedResponse | ConflictResponse

    /**
 * @summary Inicia a inscricao no segundo fator TOTP
 */
export const useEnrollMfa = <TError = UnauthorizedResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollMfa>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enrollMfa>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEnrollMfaMutationOptions(options), queryClient);
    }
    export const getVerifyMfaUrl = () => {




  return `/v1/mfa/verification`
}

/**
 * Aceita o codigo do periodo corrente e dos periodos adjacentes. O mesmo
 * codigo nao passa duas vezes.
 * @summary Verifica um codigo TOTP e satisfaz o segundo fator da sessao
 */
export const verifyMfa = async (mfaVerificationRequest: MfaVerificationRequest, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getVerifyMfaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mfaVerificationRequest)
  }
);}





export const getVerifyMfaMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | TooManyRequestsResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMfa>>, TError,{data: MfaVerificationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyMfa>>, TError,{data: MfaVerificationRequest}, TContext> => {

const mutationKey = ['verifyMfa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyMfa>>, {data: MfaVerificationRequest}> = (props) => {
          const {data} = props ?? {};

          return  verifyMfa(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyMfaMutationResult = NonNullable<Awaited<ReturnType<typeof verifyMfa>>>
    export type VerifyMfaMutationBody = MfaVerificationRequest
    export type VerifyMfaMutationError = BadRequestResponse | UnauthorizedResponse | TooManyRequestsResponse

    /**
 * @summary Verifica um codigo TOTP e satisfaz o segundo fator da sessao
 */
export const useVerifyMfa = <TError = BadRequestResponse | UnauthorizedResponse | TooManyRequestsResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMfa>>, TError,{data: MfaVerificationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyMfa>>,
        TError,
        {data: MfaVerificationRequest},
        TContext
      > => {
      return useMutation(getVerifyMfaMutationOptions(options), queryClient);
    }
